module.exports = __webpack_public_path__ + "static/media/ABOUTSTARS.39571609.png";